// Vendor + app stylesheets, imported in the same cascade order the old index.html
// declared them (Bootstrap base first, then app overrides). Parcel bundles these
// deterministically into a single CSS bundle.
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/font/Roboto/font.css";
import "../assets/css/app.css";
import "../assets/font/HelveticaNeue/fonts.css";
import "../assets/font/font-awesome/css/font-awesome.min.css";
import "../assets/css/style.css";
import "../assets/css/modern-theme.css";

// Bootstrap 4 JS (data-toggle behaviours, e.g. the mobile menu in Header.js) needs
// jQuery on window first; ./bootstrap-jquery sets it up before the bundle evaluates.
import "./bootstrap-jquery";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "/src/util/alert";

import ErrorBoundary from "./component/ErrorBoundary";
import { saveState } from "./util/redux/localStorage";
import { getStore } from "./util/redux/store";

import AppRouter from "./router";

const store = getStore();
store.subscribe(() => {
  const { me } = store.getState();
  saveState({ me: me });
});

// Last line of defence for async throws that never reach a React boundary
// (rejected promises, event-handler errors). No remote reporting configured — log only.
window.addEventListener("unhandledrejection", event => {
  console.error("Unhandled promise rejection:", event.reason);
});
window.addEventListener("error", event => {
  console.error("Uncaught error:", event.error || event.message);
});

const application = (
  <Provider store={store}>
    <div>
      <ToastContainer position="top-center" autoClose={5000} limit={3} />
      <ErrorBoundary>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </ErrorBoundary>
    </div>
  </Provider>
);

const root = createRoot(document.getElementById("app"));
root.render(application);
